// extracted by mini-css-extract-plugin
export default {"iconClass":"InformationAnnotationIcon_iconClass__-s94v"};